var Jt = Object.defineProperty, Kt = Object.defineProperties;
var Gt = Object.getOwnPropertyDescriptors;
var ze = Object.getOwnPropertySymbols;
var Xt = Object.prototype.hasOwnProperty, Qt = Object.prototype.propertyIsEnumerable;
var J = (e, t) => (t = Symbol[e]) ? t : Symbol.for("Symbol." + e), Zt = (e) => {
  throw TypeError(e);
};
var We = (e, t, r) => t in e ? Jt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Z = (e, t) => {
  for (var r in t || (t = {}))
    Xt.call(t, r) && We(e, r, t[r]);
  if (ze)
    for (var r of ze(t))
      Qt.call(t, r) && We(e, r, t[r]);
  return e;
}, Je = (e, t) => Kt(e, Gt(t));
var D = (e, t, r) => new Promise((n, o) => {
  var s = (p) => {
    try {
      c(r.next(p));
    } catch (a) {
      o(a);
    }
  }, i = (p) => {
    try {
      c(r.throw(p));
    } catch (a) {
      o(a);
    }
  }, c = (p) => p.done ? n(p.value) : Promise.resolve(p.value).then(s, i);
  c((r = r.apply(e, t)).next());
}), $ = function(e, t) {
  this[0] = e, this[1] = t;
}, Te = (e, t, r) => {
  var n = (i, c, p, a) => {
    try {
      var d = r[i](c), E = (c = d.value) instanceof $, A = d.done;
      Promise.resolve(E ? c[0] : c).then((T) => E ? n(i === "return" ? i : "next", c[1] ? { done: T.done, value: T.value } : T, p, a) : p({ value: T, done: A })).catch((T) => n("throw", T, p, a));
    } catch (T) {
      a(T);
    }
  }, o = (i) => s[i] = (c) => new Promise((p, a) => n(i, c, p, a)), s = {};
  return r = r.apply(e, t), s[J("asyncIterator")] = () => s, o("next"), o("throw"), o("return"), s;
}, Oe = (e) => {
  var t = e[J("asyncIterator")], r = !1, n, o = {};
  return t == null ? (t = e[J("iterator")](), n = (s) => o[s] = (i) => t[s](i)) : (t = t.call(e), n = (s) => o[s] = (i) => {
    if (r) {
      if (r = !1, s === "throw") throw i;
      return i;
    }
    return r = !0, {
      done: !1,
      value: new $(new Promise((c) => {
        var p = t[s](i);
        p instanceof Object || Zt("Object expected"), c(p);
      }), 1)
    };
  }), o[J("iterator")] = () => o, n("next"), "throw" in t ? n("throw") : o.throw = (s) => {
    throw s;
  }, "return" in t && n("return"), o;
}, Ke = (e, t, r) => (t = e[J("asyncIterator")]) ? t.call(e) : (e = e[J("iterator")](), t = {}, r = (n, o) => (o = e[n]) && (t[n] = (s) => new Promise((i, c, p) => (s = o.call(e, s), p = s.done, Promise.resolve(s.value).then((a) => i({ value: a, done: p }), c)))), r("next"), r("return"), t);
function Yt() {
  return null;
}
const U = {
  logError(...e) {
    console && console.error && console.error(...e);
  },
  logWarn(...e) {
    console && console.warn && console.warn(...e);
  },
  logInfo(...e) {
    console && console.info && console.info(...e);
  }
};
function er(e) {
  Object.assign(U, e);
}
var gt = /* @__PURE__ */ ((e) => (e.And = "and", e.Or = "or", e.Eq = "eq", e.Neq = "neq", e.In = "in", e.Nin = "nin", e.Gt = "gt", e.Gte = "gte", e.Lt = "lt", e.Lte = "lte", e))(gt || {});
function tr(e) {
  const t = Object.values(gt).filter((r) => typeof e[r] != "undefined");
  if (t.length > 1) throw new Error(`Multiple operators specified (${t.join(", ")})`);
}
function yt(e, t) {
  const { property: r } = e;
  if (!t.size)
    throw new Error("No restriction properties found");
  if (!t.has(r))
    throw new Error(`Unexpected restriction property: ${r}`);
  const n = t.get(r);
  if (typeof n == "function")
    return n();
  throw new Error("No restriction properties found");
}
function ee(e, t, r) {
  const n = yt(t, r.restrictionsProviders);
  return e.toLowerCase() === (n == null ? void 0 : n.toLowerCase());
}
const rr = (e, t) => e.localeCompare(t, void 0, {
  ignorePunctuation: !0,
  numeric: !0,
  sensitivity: "base"
});
function Ge(e, t, { property: r }) {
  if (r === "AppVersion") return rr(e, t) === 1;
  throw new Error(`Property is not comparable: ${r}`);
}
function he(e, t, r) {
  const n = yt(t, r.restrictionsProviders), o = t[e], s = ee(o, t, r);
  return [
    "eq",
    "gte",
    "lte"
    /* Lte */
  ].includes(e) && s ? !0 : [
    "gt",
    "gte"
    /* Gte */
  ].includes(e) ? Ge(n, o, t) : [
    "lt",
    "lte"
    /* Lte */
  ].includes(e) ? Ge(o, n, t) : !1;
}
function ge(e, t) {
  try {
    return tr(e), e.and ? e.and.every((r) => ge(r, t)) : e.or ? e.or.some((r) => ge(r, t)) : e.eq ? ee(e.eq, e, t) : e.neq ? !ee(e.neq, e, t) : e.in ? e.in.some((r) => ee(r, e, t)) : e.nin ? e.nin.every((r) => !ee(r, e, t)) : e.gt ? he("gt", e, t) : e.gte ? he("gte", e, t) : e.lt ? he("lt", e, t) : e.lte ? he("lte", e, t) : !0;
  } catch (r) {
    const n = r instanceof Error ? r.message : "Unknown error";
    return U.logWarn(n, null, { error: r }), !1;
  }
}
var te = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function wt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function nr(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var bt = { exports: {} };
function or(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Ae = { exports: {} };
const sr = {}, ir = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sr
}, Symbol.toStringTag, { value: "Module" })), ar = /* @__PURE__ */ nr(ir);
var Xe;
function Et() {
  return Xe || (Xe = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(te, function() {
      var r = r || function(n, o) {
        var s;
        if (typeof window != "undefined" && window.crypto && (s = window.crypto), typeof self != "undefined" && self.crypto && (s = self.crypto), typeof globalThis != "undefined" && globalThis.crypto && (s = globalThis.crypto), !s && typeof window != "undefined" && window.msCrypto && (s = window.msCrypto), !s && typeof te != "undefined" && te.crypto && (s = te.crypto), !s && typeof or == "function")
          try {
            s = ar;
          } catch (l) {
          }
        var i = function() {
          if (s) {
            if (typeof s.getRandomValues == "function")
              try {
                return s.getRandomValues(new Uint32Array(1))[0];
              } catch (l) {
              }
            if (typeof s.randomBytes == "function")
              try {
                return s.randomBytes(4).readInt32LE();
              } catch (l) {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, c = Object.create || /* @__PURE__ */ function() {
          function l() {
          }
          return function(h) {
            var S;
            return l.prototype = h, S = new l(), l.prototype = null, S;
          };
        }(), p = {}, a = p.lib = {}, d = a.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(l) {
              var h = c(this);
              return l && h.mixIn(l), (!h.hasOwnProperty("init") || this.init === h.init) && (h.init = function() {
                h.$super.init.apply(this, arguments);
              }), h.init.prototype = h, h.$super = this, h;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var l = this.extend();
              return l.init.apply(l, arguments), l;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(l) {
              for (var h in l)
                l.hasOwnProperty(h) && (this[h] = l[h]);
              l.hasOwnProperty("toString") && (this.toString = l.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), E = a.WordArray = d.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(l, h) {
            l = this.words = l || [], h != o ? this.sigBytes = h : this.sigBytes = l.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(l) {
            return (l || T).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(l) {
            var h = this.words, S = l.words, R = this.sigBytes, O = l.sigBytes;
            if (this.clamp(), R % 4)
              for (var _ = 0; _ < O; _++) {
                var F = S[_ >>> 2] >>> 24 - _ % 4 * 8 & 255;
                h[R + _ >>> 2] |= F << 24 - (R + _) % 4 * 8;
              }
            else
              for (var N = 0; N < O; N += 4)
                h[R + N >>> 2] = S[N >>> 2];
            return this.sigBytes += O, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var l = this.words, h = this.sigBytes;
            l[h >>> 2] &= 4294967295 << 32 - h % 4 * 8, l.length = n.ceil(h / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var l = d.clone.call(this);
            return l.words = this.words.slice(0), l;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(l) {
            for (var h = [], S = 0; S < l; S += 4)
              h.push(i());
            return new E.init(h, l);
          }
        }), A = p.enc = {}, T = A.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(l) {
            for (var h = l.words, S = l.sigBytes, R = [], O = 0; O < S; O++) {
              var _ = h[O >>> 2] >>> 24 - O % 4 * 8 & 255;
              R.push((_ >>> 4).toString(16)), R.push((_ & 15).toString(16));
            }
            return R.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(l) {
            for (var h = l.length, S = [], R = 0; R < h; R += 2)
              S[R >>> 3] |= parseInt(l.substr(R, 2), 16) << 24 - R % 8 * 4;
            return new E.init(S, h / 2);
          }
        }, v = A.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(l) {
            for (var h = l.words, S = l.sigBytes, R = [], O = 0; O < S; O++) {
              var _ = h[O >>> 2] >>> 24 - O % 4 * 8 & 255;
              R.push(String.fromCharCode(_));
            }
            return R.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(l) {
            for (var h = l.length, S = [], R = 0; R < h; R++)
              S[R >>> 2] |= (l.charCodeAt(R) & 255) << 24 - R % 4 * 8;
            return new E.init(S, h);
          }
        }, m = A.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(l) {
            try {
              return decodeURIComponent(escape(v.stringify(l)));
            } catch (h) {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(l) {
            return v.parse(unescape(encodeURIComponent(l)));
          }
        }, f = a.BufferedBlockAlgorithm = d.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new E.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(l) {
            typeof l == "string" && (l = m.parse(l)), this._data.concat(l), this._nDataBytes += l.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(l) {
            var h, S = this._data, R = S.words, O = S.sigBytes, _ = this.blockSize, F = _ * 4, N = O / F;
            l ? N = n.ceil(N) : N = n.max((N | 0) - this._minBufferSize, 0);
            var j = N * _, V = n.min(j * 4, O);
            if (j) {
              for (var q = 0; q < j; q += _)
                this._doProcessBlock(R, q);
              h = R.splice(0, j), S.sigBytes -= V;
            }
            return new E.init(h, V);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var l = d.clone.call(this);
            return l._data = this._data.clone(), l;
          },
          _minBufferSize: 0
        });
        a.Hasher = f.extend({
          /**
           * Configuration options.
           */
          cfg: d.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(l) {
            this.cfg = this.cfg.extend(l), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            f.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(l) {
            return this._append(l), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(l) {
            l && this._append(l);
            var h = this._doFinalize();
            return h;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(l) {
            return function(h, S) {
              return new l.init(S).finalize(h);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(l) {
            return function(h, S) {
              return new C.HMAC.init(l, S).finalize(h);
            };
          }
        });
        var C = p.algo = {};
        return p;
      }(Math);
      return r;
    });
  }(Ae)), Ae.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(Et());
  })(te, function(r) {
    return function(n) {
      var o = r, s = o.lib, i = s.WordArray, c = s.Hasher, p = o.algo, a = [];
      (function() {
        for (var m = 0; m < 64; m++)
          a[m] = n.abs(n.sin(m + 1)) * 4294967296 | 0;
      })();
      var d = p.MD5 = c.extend({
        _doReset: function() {
          this._hash = new i.init([
            1732584193,
            4023233417,
            2562383102,
            271733878
          ]);
        },
        _doProcessBlock: function(m, f) {
          for (var C = 0; C < 16; C++) {
            var l = f + C, h = m[l];
            m[l] = (h << 8 | h >>> 24) & 16711935 | (h << 24 | h >>> 8) & 4278255360;
          }
          var S = this._hash.words, R = m[f + 0], O = m[f + 1], _ = m[f + 2], F = m[f + 3], N = m[f + 4], j = m[f + 5], V = m[f + 6], q = m[f + 7], se = m[f + 8], ie = m[f + 9], ae = m[f + 10], ue = m[f + 11], ce = m[f + 12], le = m[f + 13], fe = m[f + 14], de = m[f + 15], g = S[0], y = S[1], w = S[2], b = S[3];
          g = E(g, y, w, b, R, 7, a[0]), b = E(b, g, y, w, O, 12, a[1]), w = E(w, b, g, y, _, 17, a[2]), y = E(y, w, b, g, F, 22, a[3]), g = E(g, y, w, b, N, 7, a[4]), b = E(b, g, y, w, j, 12, a[5]), w = E(w, b, g, y, V, 17, a[6]), y = E(y, w, b, g, q, 22, a[7]), g = E(g, y, w, b, se, 7, a[8]), b = E(b, g, y, w, ie, 12, a[9]), w = E(w, b, g, y, ae, 17, a[10]), y = E(y, w, b, g, ue, 22, a[11]), g = E(g, y, w, b, ce, 7, a[12]), b = E(b, g, y, w, le, 12, a[13]), w = E(w, b, g, y, fe, 17, a[14]), y = E(y, w, b, g, de, 22, a[15]), g = A(g, y, w, b, O, 5, a[16]), b = A(b, g, y, w, V, 9, a[17]), w = A(w, b, g, y, ue, 14, a[18]), y = A(y, w, b, g, R, 20, a[19]), g = A(g, y, w, b, j, 5, a[20]), b = A(b, g, y, w, ae, 9, a[21]), w = A(w, b, g, y, de, 14, a[22]), y = A(y, w, b, g, N, 20, a[23]), g = A(g, y, w, b, ie, 5, a[24]), b = A(b, g, y, w, fe, 9, a[25]), w = A(w, b, g, y, F, 14, a[26]), y = A(y, w, b, g, se, 20, a[27]), g = A(g, y, w, b, le, 5, a[28]), b = A(b, g, y, w, _, 9, a[29]), w = A(w, b, g, y, q, 14, a[30]), y = A(y, w, b, g, ce, 20, a[31]), g = T(g, y, w, b, j, 4, a[32]), b = T(b, g, y, w, se, 11, a[33]), w = T(w, b, g, y, ue, 16, a[34]), y = T(y, w, b, g, fe, 23, a[35]), g = T(g, y, w, b, O, 4, a[36]), b = T(b, g, y, w, N, 11, a[37]), w = T(w, b, g, y, q, 16, a[38]), y = T(y, w, b, g, ae, 23, a[39]), g = T(g, y, w, b, le, 4, a[40]), b = T(b, g, y, w, R, 11, a[41]), w = T(w, b, g, y, F, 16, a[42]), y = T(y, w, b, g, V, 23, a[43]), g = T(g, y, w, b, ie, 4, a[44]), b = T(b, g, y, w, ce, 11, a[45]), w = T(w, b, g, y, de, 16, a[46]), y = T(y, w, b, g, _, 23, a[47]), g = v(g, y, w, b, R, 6, a[48]), b = v(b, g, y, w, q, 10, a[49]), w = v(w, b, g, y, fe, 15, a[50]), y = v(y, w, b, g, j, 21, a[51]), g = v(g, y, w, b, ce, 6, a[52]), b = v(b, g, y, w, F, 10, a[53]), w = v(w, b, g, y, ae, 15, a[54]), y = v(y, w, b, g, O, 21, a[55]), g = v(g, y, w, b, se, 6, a[56]), b = v(b, g, y, w, de, 10, a[57]), w = v(w, b, g, y, V, 15, a[58]), y = v(y, w, b, g, le, 21, a[59]), g = v(g, y, w, b, N, 6, a[60]), b = v(b, g, y, w, ue, 10, a[61]), w = v(w, b, g, y, _, 15, a[62]), y = v(y, w, b, g, ie, 21, a[63]), S[0] = S[0] + g | 0, S[1] = S[1] + y | 0, S[2] = S[2] + w | 0, S[3] = S[3] + b | 0;
        },
        _doFinalize: function() {
          var m = this._data, f = m.words, C = this._nDataBytes * 8, l = m.sigBytes * 8;
          f[l >>> 5] |= 128 << 24 - l % 32;
          var h = n.floor(C / 4294967296), S = C;
          f[(l + 64 >>> 9 << 4) + 15] = (h << 8 | h >>> 24) & 16711935 | (h << 24 | h >>> 8) & 4278255360, f[(l + 64 >>> 9 << 4) + 14] = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, m.sigBytes = (f.length + 1) * 4, this._process();
          for (var R = this._hash, O = R.words, _ = 0; _ < 4; _++) {
            var F = O[_];
            O[_] = (F << 8 | F >>> 24) & 16711935 | (F << 24 | F >>> 8) & 4278255360;
          }
          return R;
        },
        clone: function() {
          var m = c.clone.call(this);
          return m._hash = this._hash.clone(), m;
        }
      });
      function E(m, f, C, l, h, S, R) {
        var O = m + (f & C | ~f & l) + h + R;
        return (O << S | O >>> 32 - S) + f;
      }
      function A(m, f, C, l, h, S, R) {
        var O = m + (f & l | C & ~l) + h + R;
        return (O << S | O >>> 32 - S) + f;
      }
      function T(m, f, C, l, h, S, R) {
        var O = m + (f ^ C ^ l) + h + R;
        return (O << S | O >>> 32 - S) + f;
      }
      function v(m, f, C, l, h, S, R) {
        var O = m + (C ^ (f | ~l)) + h + R;
        return (O << S | O >>> 32 - S) + f;
      }
      o.MD5 = c._createHelper(d), o.HmacMD5 = c._createHmacHelper(d);
    }(Math), r.MD5;
  });
})(bt);
var ur = bt.exports;
const cr = /* @__PURE__ */ wt(ur);
var lr = Et();
const vt = /* @__PURE__ */ wt(lr);
function fr(e) {
  const t = [];
  for (let r = 0; r < e.length; r++)
    t[r / 4 | 0] |= e[r] << 24 - 8 * r;
  return vt.lib.WordArray.create(t, e.length);
}
function dr(e, t) {
  const r = [];
  return t > 0 && r.push(e >>> 24), t > 1 && r.push(e >>> 16 & 255), t > 2 && r.push(e >>> 8 & 255), t > 3 && r.push(e & 255), r;
}
function St(e, t) {
  let r = e, n = t;
  Object.prototype.hasOwnProperty.call(r, "sigBytes") && Object.prototype.hasOwnProperty.call(r, "words") && (n = r.sigBytes, r = r.words);
  const o = [];
  let s, i = 0;
  for (; n > 0; )
    s = dr(r[i], Math.min(4, n)), n -= s.length, o.push(s), i++;
  return [].concat.apply([], o);
}
function Qe(e) {
  const t = cr(e), r = St(t);
  return ((r[1] << 8) + r[0]) / 65535;
}
function hr(e) {
  const t = vt.enc.Utf8.parse(e), r = Qe(t), n = St(t);
  n[0] ^= 1;
  const o = fr(n), s = Qe(o);
  return { audienceFraction: r, variantFraction: s };
}
var Ie = /* @__PURE__ */ ((e) => (e.Disabled = "disabled", e))(Ie || {});
const pr = (e) => e.sort((t, r) => r.weight - t.weight);
function mr(e, t) {
  return e.rules.find((r) => ge(r.restrictions, t)) || null;
}
function gr(e, t) {
  if (e.bucketBy === "AnonUserId") return t.anonUserId;
  throw new Error("Unexpected bucketBy ", e.bucketBy);
}
const yr = (e) => +e.weight.toFixed(1) === 1 ? e : null;
function wr(e, t) {
  if (t > 1) throw new Error(`Variant fraction must not be > 1, was ${t}.`);
  const r = e.variants.reduce((s, i) => s + i.weight, 0);
  let n = 0;
  const o = e.variants.find((s) => (n += s.weight / r, n >= t));
  if (!o) throw new Error("No matching variant found.");
  return o;
}
function br(e, t) {
  const r = mr(e, t);
  if (!r) return null;
  if (t.mode && t.mode() === Ie.Disabled)
    if (r.variants) {
      const i = pr(r.variants);
      return yr(i[0]);
    } else
      return null;
  if (r.audienceFraction === 0)
    return null;
  const n = e.prefix + gr(e, t), { audienceFraction: o, variantFraction: s } = hr(n);
  return r.audienceFraction < o ? null : wr(r, s);
}
const Er = (e, t) => {
  if (!e.evaluationLogic) return null;
  try {
    const { type: r } = e.evaluationLogic;
    if (r === "IdHash") return br(e.evaluationLogic.detail, t);
  } catch (r) {
    const n = r instanceof Error ? r.message : "Unknown error";
    U.logError(n, { error: r });
  }
  return null;
}, vr = (e, t) => {
  const r = e.defaultValueRules.find(
    (n) => ge(n.restrictions, t)
  );
  return r ? r.value : null;
}, Sr = (e, t) => {
  try {
    const { experimentKey: r, experimentVariant: n } = e;
    if (!r || !n) return;
    if (!t) {
      U.logWarn(
        `Experiment will not be tracked as no \`onTrack\` callback was provided (key: ${r}, variant: ${n})`
      );
      return;
    }
    U.logInfo(`Tracking experiment - key: ${r}, variant: ${n}`), t(r, n);
  } catch (r) {
    U.logError("An exception occurred while trying to send an experiment event", { error: r });
  }
};
class Rr {
  constructor(t) {
    this.fm = t;
  }
  peekExperiments() {
    const t = [];
    return Object.keys(this.fm.featureLookup.getFeatureKeys()).sort().forEach((r) => {
      const n = r.replace(`${this.fm.settings.keyPrefix}::`, "");
      t.push({ key: r, value: this.fm.getValue(n, [], !1) });
    }), t;
  }
}
var G = /* @__PURE__ */ ((e) => (e.Bool = "bool", e.Int = "int", e.String = "string", e))(G || {});
class Tr {
  constructor(t) {
    try {
      this.url = new URL(t);
    } catch (r) {
      U.logWarn(
        `[FeatureOverride] Invalid URL string '${t}'. Check your settings for the plugin`,
        { error: r }
      );
    }
  }
  getOverride(t, r) {
    if (!this.url) return null;
    const o = this.url.searchParams.get(`jet-fm-${t}`);
    if (!o) return null;
    r || (r = this.determineType(o));
    try {
      let s = o;
      return r === G.Bool && (s = this.stringToBoolean(o)), r === G.Int && (s = this.stringToNumber(o)), console.log(`[FeatureOverride] The Feature '${t}' has been overridden with '${s}'.`), s;
    } catch (s) {
      const i = s instanceof Error ? s.message : "Unknown error";
      return console.log(
        `[FeatureOverride] The Feature '${t}' has an override value '${o}' but cannot be casted to '${r}'. [${i}]`
      ), null;
    }
  }
  determineType(t) {
    return t.toLowerCase() === "true" || t.toLowerCase() === "false" ? G.Bool : Number.isInteger(Number(t)) ? G.Int : G.String;
  }
  stringToBoolean(t) {
    if (t.toLowerCase() === "true") return !0;
    if (t.toLowerCase() === "false") return !1;
    throw new Error("Cast error: Not a boolean");
  }
  stringToNumber(t) {
    const r = Number(t);
    if (isNaN(r)) throw new Error("Cast error: Not a number");
    return r;
  }
}
function Rt(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Or } = Object.prototype, { getPrototypeOf: je } = Object, be = /* @__PURE__ */ ((e) => (t) => {
  const r = Or.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), I = (e) => (e = e.toLowerCase(), (t) => be(t) === e), Ee = (e) => (t) => typeof t === e, { isArray: X } = Array, re = Ee("undefined");
function Ar(e) {
  return e !== null && !re(e) && e.constructor !== null && !re(e.constructor) && k(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Tt = I("ArrayBuffer");
function xr(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Tt(e.buffer), t;
}
const Cr = Ee("string"), k = Ee("function"), Ot = Ee("number"), ve = (e) => e !== null && typeof e == "object", _r = (e) => e === !0 || e === !1, pe = (e) => {
  if (be(e) !== "object")
    return !1;
  const t = je(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Br = I("Date"), Fr = I("File"), Nr = I("Blob"), Lr = I("FileList"), Pr = (e) => ve(e) && k(e.pipe), kr = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || k(e.append) && ((t = be(e)) === "formdata" || // detect form-data instance
  t === "object" && k(e.toString) && e.toString() === "[object FormData]"));
}, Dr = I("URLSearchParams"), [Ur, Ir, jr, qr] = ["ReadableStream", "Request", "Response", "Headers"].map(I), Hr = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ne(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), X(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    const s = r ? Object.getOwnPropertyNames(e) : Object.keys(e), i = s.length;
    let c;
    for (n = 0; n < i; n++)
      c = s[n], t.call(null, e[c], c, e);
  }
}
function At(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const M = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global, xt = (e) => !re(e) && e !== M;
function Fe() {
  const { caseless: e } = xt(this) && this || {}, t = {}, r = (n, o) => {
    const s = e && At(t, o) || o;
    pe(t[s]) && pe(n) ? t[s] = Fe(t[s], n) : pe(n) ? t[s] = Fe({}, n) : X(n) ? t[s] = n.slice() : t[s] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && ne(arguments[n], r);
  return t;
}
const Vr = (e, t, r, { allOwnKeys: n } = {}) => (ne(t, (o, s) => {
  r && k(o) ? e[s] = Rt(o, r) : e[s] = o;
}, { allOwnKeys: n }), e), $r = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Mr = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, zr = (e, t, r, n) => {
  let o, s, i;
  const c = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), s = o.length; s-- > 0; )
      i = o[s], (!n || n(i, e, t)) && !c[i] && (t[i] = e[i], c[i] = !0);
    e = r !== !1 && je(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, Wr = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, Jr = (e) => {
  if (!e) return null;
  if (X(e)) return e;
  let t = e.length;
  if (!Ot(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, Kr = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && je(Uint8Array)), Gr = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const s = o.value;
    t.call(e, s[0], s[1]);
  }
}, Xr = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, Qr = I("HTMLFormElement"), Zr = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, o) {
    return n.toUpperCase() + o;
  }
), Ze = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), Yr = I("RegExp"), Ct = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  ne(r, (o, s) => {
    let i;
    (i = t(o, s, e)) !== !1 && (n[s] = i || o);
  }), Object.defineProperties(e, n);
}, en = (e) => {
  Ct(e, (t, r) => {
    if (k(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (k(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, tn = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((s) => {
      r[s] = !0;
    });
  };
  return X(e) ? n(e) : n(String(e).split(t)), r;
}, rn = () => {
}, nn = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, xe = "abcdefghijklmnopqrstuvwxyz", Ye = "0123456789", _t = {
  DIGIT: Ye,
  ALPHA: xe,
  ALPHA_DIGIT: xe + xe.toUpperCase() + Ye
}, on = (e = 16, t = _t.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function sn(e) {
  return !!(e && k(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const an = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (ve(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        const s = X(n) ? [] : {};
        return ne(n, (i, c) => {
          const p = r(i, o + 1);
          !re(p) && (s[c] = p);
        }), t[o] = void 0, s;
      }
    }
    return n;
  };
  return r(e, 0);
}, un = I("AsyncFunction"), cn = (e) => e && (ve(e) || k(e)) && k(e.then) && k(e.catch), Bt = ((e, t) => e ? setImmediate : t ? ((r, n) => (M.addEventListener("message", ({ source: o, data: s }) => {
  o === M && s === r && n.length && n.shift()();
}, !1), (o) => {
  n.push(o), M.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  k(M.postMessage)
), ln = typeof queueMicrotask != "undefined" ? queueMicrotask.bind(M) : typeof process != "undefined" && process.nextTick || Bt, u = {
  isArray: X,
  isArrayBuffer: Tt,
  isBuffer: Ar,
  isFormData: kr,
  isArrayBufferView: xr,
  isString: Cr,
  isNumber: Ot,
  isBoolean: _r,
  isObject: ve,
  isPlainObject: pe,
  isReadableStream: Ur,
  isRequest: Ir,
  isResponse: jr,
  isHeaders: qr,
  isUndefined: re,
  isDate: Br,
  isFile: Fr,
  isBlob: Nr,
  isRegExp: Yr,
  isFunction: k,
  isStream: Pr,
  isURLSearchParams: Dr,
  isTypedArray: Kr,
  isFileList: Lr,
  forEach: ne,
  merge: Fe,
  extend: Vr,
  trim: Hr,
  stripBOM: $r,
  inherits: Mr,
  toFlatObject: zr,
  kindOf: be,
  kindOfTest: I,
  endsWith: Wr,
  toArray: Jr,
  forEachEntry: Gr,
  matchAll: Xr,
  isHTMLForm: Qr,
  hasOwnProperty: Ze,
  hasOwnProp: Ze,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ct,
  freezeMethods: en,
  toObjectSet: tn,
  toCamelCase: Zr,
  noop: rn,
  toFiniteNumber: nn,
  findKey: At,
  global: M,
  isContextDefined: xt,
  ALPHABET: _t,
  generateString: on,
  isSpecCompliantForm: sn,
  toJSONObject: an,
  isAsyncFn: un,
  isThenable: cn,
  setImmediate: Bt,
  asap: ln
};
function x(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o, this.status = o.status ? o.status : null);
}
u.inherits(x, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: u.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ft = x.prototype, Nt = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Nt[e] = { value: e };
});
Object.defineProperties(x, Nt);
Object.defineProperty(Ft, "isAxiosError", { value: !0 });
x.from = (e, t, r, n, o, s) => {
  const i = Object.create(Ft);
  return u.toFlatObject(e, i, function(p) {
    return p !== Error.prototype;
  }, (c) => c !== "isAxiosError"), x.call(i, e.message, t, r, n, o), i.cause = e, i.name = e.name, s && Object.assign(i, s), i;
};
const fn = null;
function Ne(e) {
  return u.isPlainObject(e) || u.isArray(e);
}
function Lt(e) {
  return u.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function et(e, t, r) {
  return e ? e.concat(t).map(function(o, s) {
    return o = Lt(o), !r && s ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function dn(e) {
  return u.isArray(e) && !e.some(Ne);
}
const hn = u.toFlatObject(u, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Se(e, t, r) {
  if (!u.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = u.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, f) {
    return !u.isUndefined(f[m]);
  });
  const n = r.metaTokens, o = r.visitor || d, s = r.dots, i = r.indexes, p = (r.Blob || typeof Blob != "undefined" && Blob) && u.isSpecCompliantForm(t);
  if (!u.isFunction(o))
    throw new TypeError("visitor must be a function");
  function a(v) {
    if (v === null) return "";
    if (u.isDate(v))
      return v.toISOString();
    if (!p && u.isBlob(v))
      throw new x("Blob is not supported. Use a Buffer instead.");
    return u.isArrayBuffer(v) || u.isTypedArray(v) ? p && typeof Blob == "function" ? new Blob([v]) : Buffer.from(v) : v;
  }
  function d(v, m, f) {
    let C = v;
    if (v && !f && typeof v == "object") {
      if (u.endsWith(m, "{}"))
        m = n ? m : m.slice(0, -2), v = JSON.stringify(v);
      else if (u.isArray(v) && dn(v) || (u.isFileList(v) || u.endsWith(m, "[]")) && (C = u.toArray(v)))
        return m = Lt(m), C.forEach(function(h, S) {
          !(u.isUndefined(h) || h === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? et([m], S, s) : i === null ? m : m + "[]",
            a(h)
          );
        }), !1;
    }
    return Ne(v) ? !0 : (t.append(et(f, m, s), a(v)), !1);
  }
  const E = [], A = Object.assign(hn, {
    defaultVisitor: d,
    convertValue: a,
    isVisitable: Ne
  });
  function T(v, m) {
    if (!u.isUndefined(v)) {
      if (E.indexOf(v) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      E.push(v), u.forEach(v, function(C, l) {
        (!(u.isUndefined(C) || C === null) && o.call(
          t,
          C,
          u.isString(l) ? l.trim() : l,
          m,
          A
        )) === !0 && T(C, m ? m.concat(l) : [l]);
      }), E.pop();
    }
  }
  if (!u.isObject(e))
    throw new TypeError("data must be an object");
  return T(e), t;
}
function tt(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function qe(e, t) {
  this._pairs = [], e && Se(e, this, t);
}
const Pt = qe.prototype;
Pt.append = function(t, r) {
  this._pairs.push([t, r]);
};
Pt.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, tt);
  } : tt;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function pn(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function kt(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || pn, o = r && r.serialize;
  let s;
  if (o ? s = o(t, r) : s = u.isURLSearchParams(t) ? t.toString() : new qe(t, r).toString(n), s) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class rt {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    u.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const Dt = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, mn = typeof URLSearchParams != "undefined" ? URLSearchParams : qe, gn = typeof FormData != "undefined" ? FormData : null, yn = typeof Blob != "undefined" ? Blob : null, wn = {
  isBrowser: !0,
  classes: {
    URLSearchParams: mn,
    FormData: gn,
    Blob: yn
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, He = typeof window != "undefined" && typeof document != "undefined", Le = typeof navigator == "object" && navigator || void 0, bn = He && (!Le || ["ReactNative", "NativeScript", "NS"].indexOf(Le.product) < 0), En = typeof WorkerGlobalScope != "undefined" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", vn = He && window.location.href || "http://localhost", Sn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: He,
  hasStandardBrowserEnv: bn,
  hasStandardBrowserWebWorkerEnv: En,
  navigator: Le,
  origin: vn
}, Symbol.toStringTag, { value: "Module" })), L = Z(Z({}, Sn), wn);
function Rn(e, t) {
  return Se(e, new L.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, o, s) {
      return L.isNode && u.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Tn(e) {
  return u.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function On(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let s;
  for (n = 0; n < o; n++)
    s = r[n], t[s] = e[s];
  return t;
}
function Ut(e) {
  function t(r, n, o, s) {
    let i = r[s++];
    if (i === "__proto__") return !0;
    const c = Number.isFinite(+i), p = s >= r.length;
    return i = !i && u.isArray(o) ? o.length : i, p ? (u.hasOwnProp(o, i) ? o[i] = [o[i], n] : o[i] = n, !c) : ((!o[i] || !u.isObject(o[i])) && (o[i] = []), t(r, n, o[i], s) && u.isArray(o[i]) && (o[i] = On(o[i])), !c);
  }
  if (u.isFormData(e) && u.isFunction(e.entries)) {
    const r = {};
    return u.forEachEntry(e, (n, o) => {
      t(Tn(n), o, r, 0);
    }), r;
  }
  return null;
}
function An(e, t, r) {
  if (u.isString(e))
    try {
      return (t || JSON.parse)(e), u.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(e);
}
const oe = {
  transitional: Dt,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", o = n.indexOf("application/json") > -1, s = u.isObject(t);
    if (s && u.isHTMLForm(t) && (t = new FormData(t)), u.isFormData(t))
      return o ? JSON.stringify(Ut(t)) : t;
    if (u.isArrayBuffer(t) || u.isBuffer(t) || u.isStream(t) || u.isFile(t) || u.isBlob(t) || u.isReadableStream(t))
      return t;
    if (u.isArrayBufferView(t))
      return t.buffer;
    if (u.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let c;
    if (s) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Rn(t, this.formSerializer).toString();
      if ((c = u.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const p = this.env && this.env.FormData;
        return Se(
          c ? { "files[]": t } : t,
          p && new p(),
          this.formSerializer
        );
      }
    }
    return s || o ? (r.setContentType("application/json", !1), An(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || oe.transitional, n = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (u.isResponse(t) || u.isReadableStream(t))
      return t;
    if (t && u.isString(t) && (n && !this.responseType || o)) {
      const i = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (c) {
        if (i)
          throw c.name === "SyntaxError" ? x.from(c, x.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: L.classes.FormData,
    Blob: L.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
u.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  oe.headers[e] = {};
});
const xn = u.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Cn = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && xn[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, nt = Symbol("internals");
function Y(e) {
  return e && String(e).trim().toLowerCase();
}
function me(e) {
  return e === !1 || e == null ? e : u.isArray(e) ? e.map(me) : String(e);
}
function _n(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const Bn = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ce(e, t, r, n, o) {
  if (u.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!u.isString(t)) {
    if (u.isString(n))
      return t.indexOf(n) !== -1;
    if (u.isRegExp(n))
      return n.test(t);
  }
}
function Fn(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function Nn(e, t) {
  const r = u.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, s, i) {
        return this[n].call(this, t, o, s, i);
      },
      configurable: !0
    });
  });
}
class P {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const o = this;
    function s(c, p, a) {
      const d = Y(p);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const E = u.findKey(o, d);
      (!E || o[E] === void 0 || a === !0 || a === void 0 && o[E] !== !1) && (o[E || p] = me(c));
    }
    const i = (c, p) => u.forEach(c, (a, d) => s(a, d, p));
    if (u.isPlainObject(t) || t instanceof this.constructor)
      i(t, r);
    else if (u.isString(t) && (t = t.trim()) && !Bn(t))
      i(Cn(t), r);
    else if (u.isHeaders(t))
      for (const [c, p] of t.entries())
        s(p, c, n);
    else
      t != null && s(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = Y(t), t) {
      const n = u.findKey(this, t);
      if (n) {
        const o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return _n(o);
        if (u.isFunction(r))
          return r.call(this, o, n);
        if (u.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = Y(t), t) {
      const n = u.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || Ce(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let o = !1;
    function s(i) {
      if (i = Y(i), i) {
        const c = u.findKey(n, i);
        c && (!r || Ce(n, n[c], c, r)) && (delete n[c], o = !0);
      }
    }
    return u.isArray(t) ? t.forEach(s) : s(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, o = !1;
    for (; n--; ) {
      const s = r[n];
      (!t || Ce(this, this[s], s, t, !0)) && (delete this[s], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, n = {};
    return u.forEach(this, (o, s) => {
      const i = u.findKey(n, s);
      if (i) {
        r[i] = me(o), delete r[s];
        return;
      }
      const c = t ? Fn(s) : String(s).trim();
      c !== s && delete r[s], r[c] = me(o), n[c] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return u.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && u.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    const n = (this[nt] = this[nt] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function s(i) {
      const c = Y(i);
      n[c] || (Nn(o, i), n[c] = !0);
    }
    return u.isArray(t) ? t.forEach(s) : s(t), this;
  }
}
P.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
u.reduceDescriptors(P.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
u.freezeMethods(P);
function _e(e, t) {
  const r = this || oe, n = t || r, o = P.from(n.headers);
  let s = n.data;
  return u.forEach(e, function(c) {
    s = c.call(r, s, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), s;
}
function It(e) {
  return !!(e && e.__CANCEL__);
}
function Q(e, t, r) {
  x.call(this, e == null ? "canceled" : e, x.ERR_CANCELED, t, r), this.name = "CanceledError";
}
u.inherits(Q, x, {
  __CANCEL__: !0
});
function jt(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new x(
    "Request failed with status code " + r.status,
    [x.ERR_BAD_REQUEST, x.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Ln(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Pn(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, s = 0, i;
  return t = t !== void 0 ? t : 1e3, function(p) {
    const a = Date.now(), d = n[s];
    i || (i = a), r[o] = p, n[o] = a;
    let E = s, A = 0;
    for (; E !== o; )
      A += r[E++], E = E % e;
    if (o = (o + 1) % e, o === s && (s = (s + 1) % e), a - i < t)
      return;
    const T = d && a - d;
    return T ? Math.round(A * 1e3 / T) : void 0;
  };
}
function kn(e, t) {
  let r = 0, n = 1e3 / t, o, s;
  const i = (a, d = Date.now()) => {
    r = d, o = null, s && (clearTimeout(s), s = null), e.apply(null, a);
  };
  return [(...a) => {
    const d = Date.now(), E = d - r;
    E >= n ? i(a, d) : (o = a, s || (s = setTimeout(() => {
      s = null, i(o);
    }, n - E)));
  }, () => o && i(o)];
}
const ye = (e, t, r = 3) => {
  let n = 0;
  const o = Pn(50, 250);
  return kn((s) => {
    const i = s.loaded, c = s.lengthComputable ? s.total : void 0, p = i - n, a = o(p), d = i <= c;
    n = i;
    const E = {
      loaded: i,
      total: c,
      progress: c ? i / c : void 0,
      bytes: p,
      rate: a || void 0,
      estimated: a && c && d ? (c - i) / a : void 0,
      event: s,
      lengthComputable: c != null,
      [t ? "download" : "upload"]: !0
    };
    e(E);
  }, r);
}, ot = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, st = (e) => (...t) => u.asap(() => e(...t)), Dn = L.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = L.navigator && /(msie|trident)/i.test(L.navigator.userAgent), r = document.createElement("a");
    let n;
    function o(s) {
      let i = s;
      return t && (r.setAttribute("href", i), i = r.href), r.setAttribute("href", i), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = o(window.location.href), function(i) {
      const c = u.isString(i) ? o(i) : i;
      return c.protocol === n.protocol && c.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), Un = L.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, o, s) {
      const i = [e + "=" + encodeURIComponent(t)];
      u.isNumber(r) && i.push("expires=" + new Date(r).toGMTString()), u.isString(n) && i.push("path=" + n), u.isString(o) && i.push("domain=" + o), s === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function In(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function jn(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function qt(e, t) {
  return e && !In(t) ? jn(e, t) : t;
}
const it = (e) => e instanceof P ? Z({}, e) : e;
function W(e, t) {
  t = t || {};
  const r = {};
  function n(a, d, E) {
    return u.isPlainObject(a) && u.isPlainObject(d) ? u.merge.call({ caseless: E }, a, d) : u.isPlainObject(d) ? u.merge({}, d) : u.isArray(d) ? d.slice() : d;
  }
  function o(a, d, E) {
    if (u.isUndefined(d)) {
      if (!u.isUndefined(a))
        return n(void 0, a, E);
    } else return n(a, d, E);
  }
  function s(a, d) {
    if (!u.isUndefined(d))
      return n(void 0, d);
  }
  function i(a, d) {
    if (u.isUndefined(d)) {
      if (!u.isUndefined(a))
        return n(void 0, a);
    } else return n(void 0, d);
  }
  function c(a, d, E) {
    if (E in t)
      return n(a, d);
    if (E in e)
      return n(void 0, a);
  }
  const p = {
    url: s,
    method: s,
    data: s,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: c,
    headers: (a, d) => o(it(a), it(d), !0)
  };
  return u.forEach(Object.keys(Object.assign({}, e, t)), function(d) {
    const E = p[d] || o, A = E(e[d], t[d], d);
    u.isUndefined(A) && E !== c || (r[d] = A);
  }), r;
}
const Ht = (e) => {
  const t = W({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: o, xsrfCookieName: s, headers: i, auth: c } = t;
  t.headers = i = P.from(i), t.url = kt(qt(t.baseURL, t.url), e.params, e.paramsSerializer), c && i.set(
    "Authorization",
    "Basic " + btoa((c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : ""))
  );
  let p;
  if (u.isFormData(r)) {
    if (L.hasStandardBrowserEnv || L.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((p = i.getContentType()) !== !1) {
      const [a, ...d] = p ? p.split(";").map((E) => E.trim()).filter(Boolean) : [];
      i.setContentType([a || "multipart/form-data", ...d].join("; "));
    }
  }
  if (L.hasStandardBrowserEnv && (n && u.isFunction(n) && (n = n(t)), n || n !== !1 && Dn(t.url))) {
    const a = o && s && Un.read(s);
    a && i.set(o, a);
  }
  return t;
}, qn = typeof XMLHttpRequest != "undefined", Hn = qn && function(e) {
  return new Promise(function(r, n) {
    const o = Ht(e);
    let s = o.data;
    const i = P.from(o.headers).normalize();
    let { responseType: c, onUploadProgress: p, onDownloadProgress: a } = o, d, E, A, T, v;
    function m() {
      T && T(), v && v(), o.cancelToken && o.cancelToken.unsubscribe(d), o.signal && o.signal.removeEventListener("abort", d);
    }
    let f = new XMLHttpRequest();
    f.open(o.method.toUpperCase(), o.url, !0), f.timeout = o.timeout;
    function C() {
      if (!f)
        return;
      const h = P.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), R = {
        data: !c || c === "text" || c === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: h,
        config: e,
        request: f
      };
      jt(function(_) {
        r(_), m();
      }, function(_) {
        n(_), m();
      }, R), f = null;
    }
    "onloadend" in f ? f.onloadend = C : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(C);
    }, f.onabort = function() {
      f && (n(new x("Request aborted", x.ECONNABORTED, e, f)), f = null);
    }, f.onerror = function() {
      n(new x("Network Error", x.ERR_NETWORK, e, f)), f = null;
    }, f.ontimeout = function() {
      let S = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const R = o.transitional || Dt;
      o.timeoutErrorMessage && (S = o.timeoutErrorMessage), n(new x(
        S,
        R.clarifyTimeoutError ? x.ETIMEDOUT : x.ECONNABORTED,
        e,
        f
      )), f = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in f && u.forEach(i.toJSON(), function(S, R) {
      f.setRequestHeader(R, S);
    }), u.isUndefined(o.withCredentials) || (f.withCredentials = !!o.withCredentials), c && c !== "json" && (f.responseType = o.responseType), a && ([A, v] = ye(a, !0), f.addEventListener("progress", A)), p && f.upload && ([E, T] = ye(p), f.upload.addEventListener("progress", E), f.upload.addEventListener("loadend", T)), (o.cancelToken || o.signal) && (d = (h) => {
      f && (n(!h || h.type ? new Q(null, e, f) : h), f.abort(), f = null);
    }, o.cancelToken && o.cancelToken.subscribe(d), o.signal && (o.signal.aborted ? d() : o.signal.addEventListener("abort", d)));
    const l = Ln(o.url);
    if (l && L.protocols.indexOf(l) === -1) {
      n(new x("Unsupported protocol " + l + ":", x.ERR_BAD_REQUEST, e));
      return;
    }
    f.send(s || null);
  });
}, Vn = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), o;
    const s = function(a) {
      if (!o) {
        o = !0, c();
        const d = a instanceof Error ? a : this.reason;
        n.abort(d instanceof x ? d : new Q(d instanceof Error ? d.message : d));
      }
    };
    let i = t && setTimeout(() => {
      i = null, s(new x(`timeout ${t} of ms exceeded`, x.ETIMEDOUT));
    }, t);
    const c = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((a) => {
        a.unsubscribe ? a.unsubscribe(s) : a.removeEventListener("abort", s);
      }), e = null);
    };
    e.forEach((a) => a.addEventListener("abort", s));
    const { signal: p } = n;
    return p.unsubscribe = () => u.asap(c), p;
  }
}, $n = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, o;
  for (; n < r; )
    o = n + t, yield e.slice(n, o), n = o;
}, Mn = function(e, t) {
  return Te(this, null, function* () {
    try {
      for (var r = Ke(zn(e)), n, o, s; n = !(o = yield new $(r.next())).done; n = !1) {
        const i = o.value;
        yield* Oe($n(i, t));
      }
    } catch (o) {
      s = [o];
    } finally {
      try {
        n && (o = r.return) && (yield new $(o.call(r)));
      } finally {
        if (s)
          throw s[0];
      }
    }
  });
}, zn = function(e) {
  return Te(this, null, function* () {
    if (e[Symbol.asyncIterator]) {
      yield* Oe(e);
      return;
    }
    const t = e.getReader();
    try {
      for (; ; ) {
        const { done: r, value: n } = yield new $(t.read());
        if (r)
          break;
        yield n;
      }
    } finally {
      yield new $(t.cancel());
    }
  });
}, at = (e, t, r, n) => {
  const o = Mn(e, t);
  let s = 0, i, c = (a) => {
    i || (i = !0, n && n(a));
  };
  return new ReadableStream({
    pull(a) {
      return D(this, null, function* () {
        try {
          const { done: d, value: E } = yield o.next();
          if (d) {
            c(), a.close();
            return;
          }
          let A = E.byteLength;
          if (r) {
            let T = s += A;
            r(T);
          }
          a.enqueue(new Uint8Array(E));
        } catch (d) {
          throw c(d), d;
        }
      });
    },
    cancel(a) {
      return c(a), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, Re = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Vt = Re && typeof ReadableStream == "function", Wn = Re && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : (e) => D(void 0, null, function* () {
  return new Uint8Array(yield new Response(e).arrayBuffer());
})), $t = (e, ...t) => {
  try {
    return !!e(...t);
  } catch (r) {
    return !1;
  }
}, Jn = Vt && $t(() => {
  let e = !1;
  const t = new Request(L.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), ut = 64 * 1024, Pe = Vt && $t(() => u.isReadableStream(new Response("").body)), we = {
  stream: Pe && ((e) => e.body)
};
Re && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !we[t] && (we[t] = u.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new x(`Response type '${t}' is not supported`, x.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const Kn = (e) => D(void 0, null, function* () {
  if (e == null)
    return 0;
  if (u.isBlob(e))
    return e.size;
  if (u.isSpecCompliantForm(e))
    return (yield new Request(L.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (u.isArrayBufferView(e) || u.isArrayBuffer(e))
    return e.byteLength;
  if (u.isURLSearchParams(e) && (e = e + ""), u.isString(e))
    return (yield Wn(e)).byteLength;
}), Gn = (e, t) => D(void 0, null, function* () {
  const r = u.toFiniteNumber(e.getContentLength());
  return r == null ? Kn(t) : r;
}), Xn = Re && ((e) => D(void 0, null, function* () {
  let {
    url: t,
    method: r,
    data: n,
    signal: o,
    cancelToken: s,
    timeout: i,
    onDownloadProgress: c,
    onUploadProgress: p,
    responseType: a,
    headers: d,
    withCredentials: E = "same-origin",
    fetchOptions: A
  } = Ht(e);
  a = a ? (a + "").toLowerCase() : "text";
  let T = Vn([o, s && s.toAbortSignal()], i), v;
  const m = T && T.unsubscribe && (() => {
    T.unsubscribe();
  });
  let f;
  try {
    if (p && Jn && r !== "get" && r !== "head" && (f = yield Gn(d, n)) !== 0) {
      let R = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), O;
      if (u.isFormData(n) && (O = R.headers.get("content-type")) && d.setContentType(O), R.body) {
        const [_, F] = ot(
          f,
          ye(st(p))
        );
        n = at(R.body, ut, _, F);
      }
    }
    u.isString(E) || (E = E ? "include" : "omit");
    const C = "credentials" in Request.prototype;
    v = new Request(t, Je(Z({}, A), {
      signal: T,
      method: r.toUpperCase(),
      headers: d.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: C ? E : void 0
    }));
    let l = yield fetch(v);
    const h = Pe && (a === "stream" || a === "response");
    if (Pe && (c || h && m)) {
      const R = {};
      ["status", "statusText", "headers"].forEach((N) => {
        R[N] = l[N];
      });
      const O = u.toFiniteNumber(l.headers.get("content-length")), [_, F] = c && ot(
        O,
        ye(st(c), !0)
      ) || [];
      l = new Response(
        at(l.body, ut, _, () => {
          F && F(), m && m();
        }),
        R
      );
    }
    a = a || "text";
    let S = yield we[u.findKey(we, a) || "text"](l, e);
    return !h && m && m(), yield new Promise((R, O) => {
      jt(R, O, {
        data: S,
        headers: P.from(l.headers),
        status: l.status,
        statusText: l.statusText,
        config: e,
        request: v
      });
    });
  } catch (C) {
    throw m && m(), C && C.name === "TypeError" && /fetch/i.test(C.message) ? Object.assign(
      new x("Network Error", x.ERR_NETWORK, e, v),
      {
        cause: C.cause || C
      }
    ) : x.from(C, C && C.code, e, v);
  }
})), ke = {
  http: fn,
  xhr: Hn,
  fetch: Xn
};
u.forEach(ke, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (r) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ct = (e) => `- ${e}`, Qn = (e) => u.isFunction(e) || e === null || e === !1, Mt = {
  getAdapter: (e) => {
    e = u.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const o = {};
    for (let s = 0; s < t; s++) {
      r = e[s];
      let i;
      if (n = r, !Qn(r) && (n = ke[(i = String(r)).toLowerCase()], n === void 0))
        throw new x(`Unknown adapter '${i}'`);
      if (n)
        break;
      o[i || "#" + s] = n;
    }
    if (!n) {
      const s = Object.entries(o).map(
        ([c, p]) => `adapter ${c} ` + (p === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? s.length > 1 ? `since :
` + s.map(ct).join(`
`) : " " + ct(s[0]) : "as no adapter specified";
      throw new x(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: ke
};
function Be(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Q(null, e);
}
function lt(e) {
  return Be(e), e.headers = P.from(e.headers), e.data = _e.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Mt.getAdapter(e.adapter || oe.adapter)(e).then(function(n) {
    return Be(e), n.data = _e.call(
      e,
      e.transformResponse,
      n
    ), n.headers = P.from(n.headers), n;
  }, function(n) {
    return It(n) || (Be(e), n && n.response && (n.response.data = _e.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = P.from(n.response.headers))), Promise.reject(n);
  });
}
const zt = "1.7.7", Ve = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Ve[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ft = {};
Ve.transitional = function(t, r, n) {
  function o(s, i) {
    return "[Axios v" + zt + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, c) => {
    if (t === !1)
      throw new x(
        o(i, " has been removed" + (r ? " in " + r : "")),
        x.ERR_DEPRECATED
      );
    return r && !ft[i] && (ft[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(s, i, c) : !0;
  };
};
function Zn(e, t, r) {
  if (typeof e != "object")
    throw new x("options must be an object", x.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const s = n[o], i = t[s];
    if (i) {
      const c = e[s], p = c === void 0 || i(c, s, e);
      if (p !== !0)
        throw new x("option " + s + " must be " + p, x.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new x("Unknown option " + s, x.ERR_BAD_OPTION);
  }
}
const De = {
  assertOptions: Zn,
  validators: Ve
}, H = De.validators;
class z {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new rt(),
      response: new rt()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, r) {
    return D(this, null, function* () {
      try {
        return yield this._request(t, r);
      } catch (n) {
        if (n instanceof Error) {
          let o;
          Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
          const s = o.stack ? o.stack.replace(/^.+\n/, "") : "";
          try {
            n.stack ? s && !String(n.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + s) : n.stack = s;
          } catch (i) {
          }
        }
        throw n;
      }
    });
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = W(this.defaults, r);
    const { transitional: n, paramsSerializer: o, headers: s } = r;
    n !== void 0 && De.assertOptions(n, {
      silentJSONParsing: H.transitional(H.boolean),
      forcedJSONParsing: H.transitional(H.boolean),
      clarifyTimeoutError: H.transitional(H.boolean)
    }, !1), o != null && (u.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : De.assertOptions(o, {
      encode: H.function,
      serialize: H.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let i = s && u.merge(
      s.common,
      s[r.method]
    );
    s && u.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (v) => {
        delete s[v];
      }
    ), r.headers = P.concat(i, s);
    const c = [];
    let p = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(r) === !1 || (p = p && m.synchronous, c.unshift(m.fulfilled, m.rejected));
    });
    const a = [];
    this.interceptors.response.forEach(function(m) {
      a.push(m.fulfilled, m.rejected);
    });
    let d, E = 0, A;
    if (!p) {
      const v = [lt.bind(this), void 0];
      for (v.unshift.apply(v, c), v.push.apply(v, a), A = v.length, d = Promise.resolve(r); E < A; )
        d = d.then(v[E++], v[E++]);
      return d;
    }
    A = c.length;
    let T = r;
    for (E = 0; E < A; ) {
      const v = c[E++], m = c[E++];
      try {
        T = v(T);
      } catch (f) {
        m.call(this, f);
        break;
      }
    }
    try {
      d = lt.call(this, T);
    } catch (v) {
      return Promise.reject(v);
    }
    for (E = 0, A = a.length; E < A; )
      d = d.then(a[E++], a[E++]);
    return d;
  }
  getUri(t) {
    t = W(this.defaults, t);
    const r = qt(t.baseURL, t.url);
    return kt(r, t.params, t.paramsSerializer);
  }
}
u.forEach(["delete", "get", "head", "options"], function(t) {
  z.prototype[t] = function(r, n) {
    return this.request(W(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
u.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(s, i, c) {
      return this.request(W(c || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: i
      }));
    };
  }
  z.prototype[t] = r(), z.prototype[t + "Form"] = r(!0);
});
class $e {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(s) {
      r = s;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners) return;
      let s = n._listeners.length;
      for (; s-- > 0; )
        n._listeners[s](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let s;
      const i = new Promise((c) => {
        n.subscribe(c), s = c;
      }).then(o);
      return i.cancel = function() {
        n.unsubscribe(s);
      }, i;
    }, t(function(s, i, c) {
      n.reason || (n.reason = new Q(s, i, c), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new $e(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
function Yn(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function eo(e) {
  return u.isObject(e) && e.isAxiosError === !0;
}
const Ue = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Ue).forEach(([e, t]) => {
  Ue[t] = e;
});
function Wt(e) {
  const t = new z(e), r = Rt(z.prototype.request, t);
  return u.extend(r, z.prototype, t, { allOwnKeys: !0 }), u.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return Wt(W(e, o));
  }, r;
}
const B = Wt(oe);
B.Axios = z;
B.CanceledError = Q;
B.CancelToken = $e;
B.isCancel = It;
B.VERSION = zt;
B.toFormData = Se;
B.AxiosError = x;
B.Cancel = B.CanceledError;
B.all = function(t) {
  return Promise.all(t);
};
B.spread = Yn;
B.isAxiosError = eo;
B.mergeConfig = W;
B.AxiosHeaders = P;
B.formToJSON = (e) => Ut(u.isHTMLForm(e) ? new FormData(e) : e);
B.getAdapter = Mt.getAdapter;
B.HttpStatusCode = Ue;
B.default = B;
const to = (e, t, r) => {
  const n = r && r.mode && typeof r.mode == "function" && r.mode() === Ie.Disabled;
  return !!(e && t && t.experimentKey && t.experimentVariant && !n);
}, dt = (e) => Me(e) === "string", ht = (e) => Me(e) === "boolean", pt = (e) => Me(e) === "number" && Number.isSafeInteger(e), Me = (e) => {
  const t = typeof e;
  if (t !== "object") return t;
  const r = (s) => s[0].toLowerCase() + s.slice(1), n = Object.prototype.toString.call(e).replace(/^\[object (\S+)\]$/, "$1");
  return r(n);
}, ro = "x-amz-version-id";
let mt;
class no {
  constructor() {
    this.featureLookup = {}, this.configCreatedAt = "", this.versionId = "";
  }
  fetchAndUpdate(t, r, n = () => {
  }) {
    return D(this, null, function* () {
      const o = yield r.get(t), s = o == null ? void 0 : o.headers;
      return s && (this.versionId = s[ro]), this.init(o.data, n), o.data;
    });
  }
  loadFromCdn(t, r, n) {
    return D(this, null, function* () {
      const o = this.buildUrl(t), s = yield this.fetchAndUpdate(o, r, n);
      if (clearInterval(mt), t.poll) {
        const i = t.pollInterval || 3e4;
        mt = setInterval(() => {
          this.fetchAndUpdate(o, r, n);
        }, i);
      }
      return s;
    });
  }
  init(t, r = () => {
  }) {
    const n = typeof t == "string" ? JSON.parse(t) : t;
    this.configCreatedAt >= n.createdAt || (this.configCreatedAt = n.createdAt, this.configCreatedAt && (U.logInfo(`Loading new feature config - created at: ${this.configCreatedAt}`), this.featureLookup = {}, n.features.forEach((o) => {
      this.featureLookup[o.key] = o;
    }), r()));
  }
  getFeature(t) {
    return this.featureLookup[t];
  }
  getFeatureKeys() {
    return this.featureLookup;
  }
  getFeatureKeysByTags(t = []) {
    if (t.length == 0)
      return this.getFeatureKeys();
    const n = Object.values(this.featureLookup).filter(
      (s) => s.tags && s.tags.some((i) => t.includes(i))
    ), o = {};
    return n.forEach((s) => {
      o[s.key] = s;
    }), o;
  }
  getFilteredConfigByTags(t = []) {
    let r = Object.values(this.featureLookup);
    t.length > 0 && (r = r.filter(
      (o) => o.tags && o.tags.some((s) => t.includes(s))
    ));
    const n = this.configCreatedAt;
    return { features: r, createdAt: n };
  }
  getVersionId() {
    return this.versionId;
  }
  buildUrl(t) {
    const r = t.host || "https://features.api.justeattakeaway.com", n = t.key ? `-${t.key}` : "", o = this.isNullOrWhiteSpace(t.versionId) ? "" : `?versionId=${t.versionId}`;
    return `${r}/config/v1/${t.scope}/${t.environment}${n}${o}`;
  }
  isNullOrWhiteSpace(t) {
    return t == null || t.trim() === "";
  }
}
const K = (e, t, r) => {
  U.logInfo(`${e.name}: ${t} => ${r}`);
};
class oo {
  constructor(t, r) {
    var n;
    if (this.settings = t, r)
      this.httpClient = r;
    else {
      let o = {};
      (n = t.cdn) != null && n.poll && (o = {
        headers: {
          "cache-control": "no-cache"
        }
      }), this.httpClient = B.create(o);
    }
    this.getContext = t.getContext, this.onTrack = t.onTrack, this.observer = new Rr(this), this.override = t.urlString ? new Tr(t.urlString) : null, this.featureLookup = new no(), this.settings.initialConfigAsJson && this.featureLookup.init(this.settings.initialConfigAsJson);
  }
  getQualifiedKey(t) {
    if (t.includes("::")) return t;
    const { keyPrefix: r } = this.settings;
    return r ? `${r}::${t}` : t;
  }
  getValue(t, r = [], n = !0) {
    try {
      const o = this.featureLookup.getFeature(this.getQualifiedKey(t));
      if (r.length > 0 && o.tags && !o.tags.some((d) => r.includes(d)))
        return null;
      const i = o && o.valueType || null, c = this.override ? this.override.getOverride(t, i) : null;
      if (c !== null) return c;
      if (!o) return null;
      const p = this.getContext();
      if (!p)
        return U.logError(
          "Unable to provide feature values as no context was provided. Check your settings for the plugin"
        ), null;
      const a = Er(o, p);
      return a ? (to(n, a, p) && Sr(a, this.onTrack), a.value) : vr(o, p);
    } catch (o) {
      const s = o instanceof Error ? o.message : "Unknown error";
      U.logError(s, { error: o });
    }
    return null;
  }
  getCompositeStringValue(t, r, n = []) {
    const o = this.getValue(t, n);
    if (o === null || !r) return null;
    const s = o[r];
    return dt(s) ? (K(this.getStringValue, t, s), s) : null;
  }
  getCompositeBoolValue(t, r, n = []) {
    const o = this.getValue(t, n);
    if (o === null || !r) return null;
    const s = o[r];
    return ht(s) ? (K(this.getBooleanValue, t, s), !!s) : null;
  }
  getCompositeIntValue(t, r, n = []) {
    const o = this.getValue(t, n);
    if (o === null || !r) return null;
    const s = o[r];
    return pt(s) ? (K(this.getIntegerValue, t, s), Number(s)) : null;
  }
  getBooleanValue(t, r = []) {
    const n = this.getValue(t, r);
    return n === null ? null : ht(n) ? (K(this.getBooleanValue, t, n), !!n) : null;
  }
  getIntegerValue(t, r = []) {
    const n = this.getValue(t, r);
    return n == null ? null : pt(n) ? (K(this.getIntegerValue, t, n), Number(n)) : null;
  }
  getStringValue(t, r = []) {
    const n = this.getValue(t, r);
    return n === null ? null : dt(n) ? (K(this.getStringValue, t, n), `${n}`) : null;
  }
  loadFromCdn() {
    return D(this, null, function* () {
      return this.loadConfigFromCdn();
    });
  }
  loadFromCdnWithVersionId() {
    return D(this, null, function* () {
      const t = yield this.loadConfigFromCdn(), r = this.featureLookup.getVersionId();
      return { config: t, versionId: r };
    });
  }
  loadConfigFromCdn() {
    return D(this, null, function* () {
      if (!this.settings.cdn) throw new Error("CDN settings were not provided.");
      return this.featureLookup.loadFromCdn(
        this.settings.cdn,
        this.httpClient,
        this.settings.onUpdated
      );
    });
  }
  updateConfig(t) {
    this.featureLookup.init(t);
  }
}
const io = (e, t) => (e.logger && e.logger && er(e.logger), e.getContext || (e.getContext = Yt), new oo(e, t));
export {
  io as createFeatureManager
};
